// import { assets } from '../const';
import { useToggleStore } from '../hooks/useTogger';
import { useWindowHeight } from '../hooks/useWindowHeight';
import { JSX, useState, useEffect } from 'react';
import { useLogout } from '../hooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProfileContext } from '@/hooks/useProfileContext';

import {
  User,
  Cable,
  ContactRound,
  Gift,
  ShoppingCart,
  Gem,
  LogOut,
  Shield,
  Settings,
  Cookie,
  List,
  Home,
} from 'lucide-react';
import { checkIsPermissionWithScreen, cn } from '@/lib/utils';
interface IMenuBarProps {
  name: string;
  icon: JSX.Element;
  path: string;
  active: boolean;
}

function MenuBar() {
  const { width } = useToggleStore();
  const windowHeight = useWindowHeight();
  const { mutateAsync: logout } = useLogout();
  const navigate = useNavigate();
  const location = useLocation();

  const { profile } = useProfileContext();

  const [activeMenu, setActiveMenu] = useState<string>(location.pathname);

  const handleLogout = async () => {
    await logout();
  };

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location.pathname]);

  const listMenu: IMenuBarProps[] = [
    {
      name: 'Dashboard',
      icon: <Home height={20} width={20} />,
      path: '/admin/dashboard',
      active: true,
    },
    {
      name: 'Quản lý nhân viên',
      icon: <User height={20} width={20} />,
      path: '/admin/manage-employees',
      active:
        checkIsPermissionWithScreen(
          'users',
          'read',
          profile?.role?.permissions
        ) ?? false,
    },
    {
      name: 'Quản lý khách hàng',
      icon: <ContactRound height={20} width={20} />,
      path: '/admin/manage-customers',
      active:
        checkIsPermissionWithScreen(
          'customers',
          'read',
          profile?.role?.permissions
        ) ?? false,
    },
    {
      name: 'Quản lý nhà cung cấp',
      icon: <Cable height={20} width={20} />,
      path: '/admin/manage-suppliers',
      active:
        checkIsPermissionWithScreen(
          'supplier',
          'read',
          profile?.role?.permissions
        ) ?? false,
    },
    {
      name: 'Quản lý quà tặng',
      icon: <Gift height={20} width={20} />,
      path: '/admin/manage-gifts',
      active:
        checkIsPermissionWithScreen(
          'gifts',
          'read',
          profile?.role?.permissions
        ) ?? false,
    },
    {
      name: 'Quản lý đơn hàng',
      icon: <ShoppingCart height={20} width={20} />,
      path: '/admin/manage-orders',
      active:
        checkIsPermissionWithScreen(
          'orders',
          'read',
          profile?.role?.permissions
        ) ?? false,
    },
    {
      name: 'Quản lý yêu cầu tặng quà',
      icon: <Gem height={20} width={20} />,
      path: '/admin/manage-gift-requests',
      active:
        checkIsPermissionWithScreen(
          'gifts-requests',
          'read',
          profile?.role?.permissions
        ) ?? false,
    },
    {
      name: 'Crawl Facebook',
      icon: <Cookie height={20} width={20} />,
      path: '/admin/crawl-fb',
      active: true,
    },
    {
      name: 'Danh sách crawl Facebook',
      icon: <List height={20} width={20} />,
      path: '/admin/list-crawl-fb',
      active: true,
    },
    {
      name: 'Quản lý phân quyền',
      icon: <Shield height={20} width={20} />,
      path: '/admin/manage-roles',
      active: profile?.role?.key === 'admin',
    },
  ];

  const handlePushChangePassword = () => {
    navigate('/admin/change-password');
  };

  return (
    <div
      style={{
        width: `${width}px`,
        height: `${windowHeight}px`,
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: `translateX(0)`,
      }}
      className={`h-full border-r border-luxury-200 md:relative absolute z-10 luxury-theme bg-white/90 backdrop-blur-md shadow-[0_0_15px_rgba(0,0,0,0.05)]`}
    >
      <div className="px-6 h-[69px] flex items-center justify-between border-b border-luxury-200">
        {/* <img
          src={assets.icLogo}
          alt="logo"
          className={`h-full w-20 object-contain transition-opacity duration-300 ${
            width === 80 ? 'opacity-90' : 'opacity-100'
          }`}
        /> */}
        <span
          className={cn(
            'bg-gradient-to-r from-luxury-300 via-luxury-400 to-luxury-500 bg-clip-text text-transparent animate-gradient block font-black tracking-widest transition-all duration-500 drop-shadow-[0_8px_8px_rgba(0,0,0,0.5)] luxury-gradient-horizontal relative',
            width === 80 ? 'text-sm' : 'text-3xl'
          )}
        >
          <span className="absolute inset-0 bg-gradient-to-r from-luxury-200/20 via-luxury-300/20 to-luxury-400/20 blur-xl -z-10"></span>
          AI DAY CRM
        </span>
      </div>
      <div
        className={`h-[calc(100%-8.4rem)] ${
          width === 80 ? 'px-2' : 'px-6'
        } overflow-y-auto scrollbar-thin scrollbar-thumb-luxury-300 scrollbar-track-transparent`}
      >
        <div className="flex gap-2 flex-col mt-4">
          {listMenu.map((item) =>
            item.active ? (
              <div key={item.path}>
                <div
                  className={`flex items-center gap-3 h-11 mb-2 cursor-pointer px-3 rounded-lg text-sm transition-all duration-300 ease-in-out hover:bg-luxury-600 hover:text-white group ${
                    activeMenu === item.path
                      ? 'bg-luxury-600 text-white shadow-[0_4px_12px_rgba(0,0,0,0.1)]'
                      : 'text-luxury-900 hover:translate-x-1'
                  } ${width === 80 ? 'justify-center' : ''}`}
                  onClick={() => {
                    navigate(item.path);
                    // setActiveMenu(item.path);
                    document.title = item.name;
                  }}
                >
                  <div
                    className={`transition-transform duration-300 ${
                      activeMenu === item.path
                        ? 'scale-110'
                        : 'group-hover:scale-110'
                    }`}
                  >
                    {item.icon}
                  </div>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      width === 80 ? 'w-0' : 'w-auto'
                    }`}
                  >
                    <span
                      className={`whitespace-nowrap inline-block transition-transform duration-300 font-medium ${
                        width === 80 ? 'translate-x-[-100%]' : 'translate-x-0'
                      }`}
                    >
                      {item.name}
                    </span>
                  </div>
                </div>
                <div className="luxury-divider mb-2"></div>
              </div>
            ) : (
              <div className="hidden" key={item.path}></div>
            )
          )}
        </div>
      </div>
      <div className="h-[4rem] px-6 flex items-center justify-between relative bg-white/90 backdrop-blur-md z-10 border-t border-luxury-200 shadow-[0_-2px_10px_rgba(0,0,0,0.02)]">
        <div className="flex items-center flex-1">
          <div className="luxury-badge ring-2 ring-luxury-200 ring-offset-2 ring-offset-white transition-all duration-300 hover:ring-luxury-400">
            <span className="text-white text-sm font-medium">
              {profile?.name.charAt(0)}
            </span>
          </div>
          <div
            className={`overflow-hidden transition-all duration-300${
              width === 80 ? 'w-0 hidden' : 'w-auto'
            }`}
          >
            <div
              className={`inline-block transition-transform duration-300 ml-3 max-w-[120px] break-words break-all ${
                width === 80 ? 'translate-x-[-100%]' : 'translate-x-0'
              }`}
            >
              <span className="text-luxury-900 font-medium text-sm">
                {profile?.name}
              </span>
            </div>
          </div>
        </div>
        <div
          className={`overflow-hidden transition-all duration-300 ${
            width === 80 ? 'w-0' : 'w-auto'
          }`}
        >
          <div
            className={`whitespace-nowrap inline-block transition-transform duration-300 ${
              width === 80 ? 'translate-x-[-100%]' : 'translate-x-0'
            }`}
          >
            <div
              onClick={() => handlePushChangePassword()}
              className="flex items-center cursor-pointer text-luxury-600 hover:text-luxury-800 transition-colors p-2 rounded-full hover:bg-luxury-100"
            >
              <Settings size={20} />
            </div>
          </div>
        </div>
        <div
          className={`overflow-hidden transition-all duration-300 ${
            width === 80 ? 'w-0' : 'w-auto'
          }`}
        >
          <div
            className={`whitespace-nowrap inline-block transition-transform duration-300 ${
              width === 80 ? 'translate-x-[-100%]' : 'translate-x-0'
            }`}
          >
            <div
              onClick={() => handleLogout()}
              className="flex items-center cursor-pointer text-luxury-600 hover:text-luxury-800 transition-colors p-2 rounded-full hover:bg-luxury-100"
            >
              <LogOut size={20} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MenuBar;
